import { Item } from "../../types/item";
import { useAuth, useMenu } from "../../hooks";
import { useMenuStore } from "../../stores";
import APIs from "../../apis";

export interface Props {
  items: Item[];
  loading: boolean;
  removeFavorite: (item: Item) => void;
}

const useViewModel = (): Props => {
  const { favorites: items } = useMenu();
  const loading = useMenuStore((state) => state.loading);
  const { refreshUser } = useAuth();

  const removeFavorite = async (item: Item) => {
    await APIs.auth.modifyFavorite(item.uuid);
    await refreshUser();
  };

  return {
    items,
    loading,
    removeFavorite,
  };
};

export default useViewModel;
